// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2iNNh","consentsList":"PatientConsents_consentsList__1DQh-","consentsListEmpty":"PatientConsents_consentsListEmpty__x1LpI"};